import React, { useState } from 'react';
import styles from './AdminHeader.module.css';

const AdminHeader = ({ onMenuClick }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  return (
    <header className={styles.adminHeader}>
      
      <div className={styles.leftSection}>
        <button className={styles.menuButton} onClick={onMenuClick}>
          <span className={styles.menuIcon}>☰</span>
        </button>
        <h1 className={styles.logo}>Panel de Administración</h1>
      </div>

      <div className={styles.rightSection}>
        <div className={styles.userInfo}>
          <div 
            className={styles.avatar}
            onClick={() => setIsProfileOpen(!isProfileOpen)}
          >
            AD
          </div>
          {isProfileOpen && (
            <div className={styles.profileDropdown}>
              <div className={styles.profileItem}>
                <span>👤</span>
                Mi Perfil
              </div>
              <div className={styles.profileItem}>
                <span>⚙️</span>
                Configuración
              </div>
              <div className={styles.profileItem}>
                <span>🚪</span>
                Cerrar Sesión
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;